import React from 'react'
import { Card, Col, Flex, Row, Typography } from 'antd'
import Slider from 'react-slick'
const { Text, Title } = Typography
const WhoWe = () => {

    const whoData = [
        {
            key: '1',
            img: 'talent.png',
            title: 'The best talent',
            description: 'Discover reliable professionals by exploring their portfolios and immersing yourself in the feedback shared on their profiles.'
        },
        {
            key: '2',
            img: 'bid.png',
            title: 'Fast bids',
            description: 'Get quick, no-obligation quotes from skilled freelancers. 80% of jobs receive bids within 60 seconds. Your idea is just moments from reality.'
        },
        {
            key: '3',
            img: 'quality.png',
            title: 'Quality work',
            description: 'Discover reliable professionals by exploring their portfolios and immersing yourself in the feedback shared on their profiles.'
        },
        {
            key: '4',
            img: 'control.png',
            title: 'Be in control',
            description: 'Discover reliable professionals by exploring their portfolios and immersing yourself in the feedback shared on their profiles.'
        },
    ]

    var testimonialSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        nextArrow: <img src='/assets/icons/arrow-right.png' width={30} />,
        prevArrow: <img src='/assets/icons/arrow-right.png' width={30} />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false,
                }
            }
        ]
    }


    return (
        <div className='m-top-130'>
            <div className='container'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical align='center' gap={10} className='mb-3'>
                            <Title className='gradient-text text-center m-0'>
                                Make it real with Freelancer
                            </Title>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Slider {...testimonialSlider}>
                            {
                                whoData?.map((data, index) => {
                                    return (
                                        <div className='py-3 px-2'>
                                            <Card className='bg-transparent card-hover border0 rounded shadow-d h-100' key={index}>
                                                <Flex vertical gap={15}>
                                                    <Flex vertical gap={15} align='center'>
                                                        <div className='icon-div1'>
                                                            <img src={"/assets/icons/" + data?.img} width={45} alt="" />
                                                        </div>
                                                        <Title level={3} className=' m-0'>
                                                            {
                                                                data?.title
                                                            }
                                                        </Title>
                                                        <Text className=''>
                                                            {
                                                                data?.description
                                                            }
                                                        </Text>
                                                    </Flex>
                                                </Flex>
                                            </Card>
                                        </div>
                                    )
                                })
                            }
                        </Slider>
                    </Col>
                    {/* {
                    data?.map((data)=>
                        <Col lg={{span:6}} md={{span: 8}} sm={{span: 24}} xs={{span: 24}}>
                            <Card className='bg-transparent card-hover border0 rounded shadow-d h-100'>
                                <Flex vertical gap={15}>
                                    <Flex vertical gap={15} align='center'>
                                        <div className='icon-div1'>
                                            <img src={"/assets/icons/"+data?.img} width={45} alt="" />
                                        </div>
                                        <Title level={3} className=' m-0'>
                                            {
                                                data?.title
                                            }
                                        </Title>
                                        <Text className='text-justify'>
                                            {
                                                data?.description
                                            }
                                        </Text>
                                    </Flex>
                                </Flex>
                            </Card>
                        </Col>
                    )
                } */}
                </Row>
            </div>
        </div>
    )
}

export { WhoWe }